import TextField from '@mui/material/TextField';
import styled from '@mui/system/styled';

export const Input = styled(TextField)(({ theme }) => ({
  marginBottom: 24,
  input: {
    backgroundColor: 'white'
  },
  svg: {
    cursor: 'pointer'
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0
  }
}));
